<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs v-show="filter_cell">
            <!-- 组级策略 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.group1") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="tan_group_level()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.group5") }}</el-button>
                        <el-alert :title="this.load_hind1" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList" :row-class-name="tableRowClassName" v-loading="loading">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="60"> </el-table-column>
                            <el-table-column prop="GROUP_NAME" :label="$t('logs.group6')">
                            </el-table-column>

                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template slot-scope="scope">
                                    <!-- 删除-->

                                    <el-button @click="handleClick_group(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>
                                    <!-- 	组成员设置-->

                                    <el-button @click="bianji1(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.group1_a1") }}</el-button>
                                    <!--    组规则设置-->

                                    <el-button @click="bianji2(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.group1_a2") }}</el-button>
                                    <!--    组收信个性化设置-->

                                    <el-button @click="bianji3(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.group1_a3") }}</el-button>
                                    <!--     组发信个性化设置  -->

                                    <el-button @click="bianji4(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.group1_a4") }}</el-button>
                                </template>

                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu_group"  v-drag="{ handle: '.pop_up_text_cert_domain' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_cert_domain"><span class="span_pad"></span> {{$t('logs.group5')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.group6") }}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="group_name" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_group" :disabled="$root.jurisdiction.only_query == 0">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="cancel_group()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_group"></div>
                </div>
            </el-tab-pane>
            <!-- 过滤规则 -->
            <el-tab-pane label="过滤规则">
                <span slot="label">{{ $t("logs.group2") }}</span>
                <div class="main">
                    <p>

                        <el-alert :title="this.load_hind2" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList1" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="50"> </el-table-column>
                            <el-table-column prop="GROUP_NAME" :label="$t('logs.group6')">
                            </el-table-column>
                            <el-table-column prop="SHOWTYPE" :label="$t('table1.type')">
                            </el-table-column>
                            <el-table-column prop="HEADER_KEY" :label="$t('table1.header')">
                            </el-table-column>
                            <el-table-column prop="SHOWDIRECT" :label="$t('logs.firewall2_a2')">
                            </el-table-column>
                            <el-table-column prop="SCORE" :label="$t('table1.score')">
                            </el-table-column>
                            <el-table-column prop="GROUP_REGEX" :label="$t('table1.rule')">
                            </el-table-column>

                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template slot-scope="scope">
                                    <!-- 删除-->

                                    <el-button @click="handleClick_regex(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>

                                </template>

                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    策略用户:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">保存</el-button>
                            <el-button type="primary" @click="tanOff()">取消</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- IP白名单 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("tabs.ipw") }}</span>
                <div class="main">
                    <p>

                        <el-alert :title="this.load_hind3" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList2" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')"> </el-table-column>
                            <el-table-column prop="GROUP_NAME" :label="$t('logs.group6')">
                            </el-table-column>
                            <el-table-column prop="IP" :label="$t('logs.network1_a5')"> </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template slot-scope="scope">
                                    <!-- 删除-->

                                    <el-button @click="handleClick_white(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>

                                </template>

                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    策略用户:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">保存</el-button>
                            <el-button type="primary" @click="tanOff()">取消</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- IP黑名单 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("tabs.ipb") }}</span>
                <div class="main">
                    <p>

                        <el-alert :title="this.load_hind4" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList3" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')"> </el-table-column>
                            <el-table-column prop="GROUP_NAME" :label="$t('logs.group6')">
                            </el-table-column>
                            <el-table-column prop="IP" :label="$t('logs.network1_a5')"> </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')"> <template slot-scope="scope">
                                    <!-- 删除-->

                                    <el-button @click="handleClick_black(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>

                                </template></el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    策略用户:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">保存</el-button>
                            <el-button type="primary" @click="tanOff()">取消</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- From白名单 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("tabs.fromw") }}</span>
                <div class="main">
                    <p>

                        <el-alert :title="this.load_hind5" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList4" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')"> </el-table-column>
                            <el-table-column prop="GROUP_NAME" :label="$t('logs.group6')">
                            </el-table-column>
                            <el-table-column prop="DNOREMAIL" :label="$t('logs.notify7')"> </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')"> <template slot-scope="scope">
                                    <!-- 删除-->

                                    <el-button @click="handleClick_from(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>

                                </template></el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    策略用户:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">保存</el-button>
                            <el-button type="primary" @click="tanOff()">取消</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- From黑名单 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("tabs.fromb") }}</span>
                <div class="main">
                    <p>

                        <el-alert :title="this.load_hind6" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList5" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')"> </el-table-column>
                            <el-table-column prop="GROUP_NAME" :label="$t('logs.group6')">
                            </el-table-column>
                            <el-table-column prop="DNOREMAIL" :label="$t('logs.notify7')"> </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')"> <template slot-scope="scope">
                                    <!-- 删除-->

                                    <el-button @click="handleClick_black_from(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>

                                </template> </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    策略用户:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">保存</el-button>
                            <el-button type="primary" @click="tanOff()">取消</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- 收信个性化 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.group3") }}</span>
                <div class="main">
                    <p>

                        <el-alert :title="this.load_hind7" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList6" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="60"> </el-table-column>
                            <el-table-column prop="GROUP_NAME" :label="$t('logs.group7_a1')">
                            </el-table-column>
                            <el-table-column prop="POLICY" :label="$t('logs.policy7')"> </el-table-column>
                            <el-table-column prop="NOTE_TYPE" :label="$t('logs.policy12')"> </el-table-column>
                            <el-table-column prop="OBJ" :label="$t('logs.policy13')"> </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.policy14')" width="200"> <template scope="scope">
                                    <el-select size="small" v-model="scope.row.ACTION" placeholder="请选择">
                                        <el-option v-for="item in actionn" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                    <span>{{ scope.row.date }}</span>
                                </template> </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')"> <template slot-scope="scope">
                                    <!-- 保存-->

                                    <el-button @click="handleClick_in(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.save") }}</el-button>

                                </template></el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    策略用户:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">保存</el-button>
                            <el-button type="primary" @click="tanOff()">取消</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- 发信个性化 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.group4") }}</span>
                <div class="main">
                    <p>

                        <el-alert :title="this.load_hind8" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList7">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="60"> </el-table-column>
                            <el-table-column prop="GROUP_NAME" :label="$t('logs.group7_a1')">
                            </el-table-column>
                            <el-table-column prop="POLICY" :label="$t('logs.policy7')"> </el-table-column>
                            <el-table-column prop="NOTE_TYPE" :label="$t('logs.policy12')"> </el-table-column>
                            <el-table-column prop="OBJ" :label="$t('logs.policy13')"> </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.policy14')" width="200"> <template scope="scope">
                                    <el-select size="small" v-model="scope.row.ACTION" placeholder="请选择">
                                        <el-option v-for="item in actionn1" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                    <span>{{ scope.row.date }}</span>
                                </template> </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')"> <template slot-scope="scope">
                                    <!-- 保存-->

                                    <el-button @click="handleClick_out(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.save") }}</el-button>

                                </template></el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    策略用户:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">保存</el-button>
                            <el-button type="primary" @click="tanOff()">取消</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <!-- 组成员设置 -->
        <el-tabs v-show="tanchu_sender_all" v-loading="loading">

            <!-- 策略组所属用户 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.group7_a3") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="save_sender_hide()">{{ $t("logs.Policy_back") }}</el-button>

                        <el-button @click="save_sender_show()">{{ $t("logs.ldap15") }}</el-button>

                    </p>
                </div>
                <div class="switch1">
                    <div class="table table01">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_group_email" :row-class-name="tableRowClassName">

                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')">
                            </el-table-column>
                            <el-table-column prop="USER_IN_GROUP" :label="$t('logs.group7_a1')">
                            </el-table-column>
                            <el-table-column prop="USERNAME" :label="$t('logs.autu5_a2')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('table1.operation')">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick_sender(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("table1.delete") }}
                                    </el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu_sender" v-drag="{ handle: '.pop_up_text_relay_domain' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_relay_domain"><span class="span_pad"></span> {{$t('logs.ldap15')}}</div>
                        <p></p>
                        <div class="find">

                            <div class="find1">
                                <div class="find-text" style="padding-right: 12px;">
                                    <!-- 域名或邮箱账号 -->
                                    {{ $t("logs.notify7") }}:

                                </div>
                                <div class="block block1">
                                    <el-input type="textarea" :autosize="{ minRows: 4, }" placeholder="一行一个地址" v-model="group_users" style="margin:8px 0">
                                    </el-input>
                                </div>
                            </div>

                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_sender" :disabled="$root.jurisdiction.only_query == 0">{{ $t("tab.save") }}</el-button>
                            <el-button type="danger" @click="off_sender">{{ $t("tab.cancel") }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_sender"></div>
                </div>
            </el-tab-pane>
            <!-- 策略组所属部门-->
            <el-tab-pane label="" v-if="this.add_depapt==1">
                <span slot="label"> {{ $t("logs.group7_a2") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="save_sender_hide()" :disabled="$root.jurisdiction.only_query == 0">{{ $t("logs.Policy_back") }}</el-button>

                        <span class="main_text"> {{ $t("logs.group7_a4") }}:</span>

                        <el-select v-model="domain_id" placeholder="请选择" filterable style="width:24%" @change="domain_id_select">
                            <el-option v-for="item in domain_idd" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        <span class="main_text"> {{ $t("logs.group7_a5") }}:</span>

                        <el-select v-model="depart_id" placeholder="请选择" style="width:26%" filterable>
                            <el-option v-for="item in depart_idd" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        <span class="main_text"> {{ $t("logs.group7_a6") }}:</span>
                        <el-checkbox v-model="include_sub_depart"></el-checkbox>
                        <el-button @click="save_depart()">{{ $t("logs.Conditional7") }}</el-button>
                    </p>
                </div>

                <div class="switch1">
                    <div class="table table01">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_group_deport" :row-class-name="tableRowClassName">

                            <el-table-column prop="DEPART_IN_GROUP" :label="$t('logs.group7_a1')" width="140">
                            </el-table-column>
                            <el-table-column prop="DEPART_IN_DOMAIN" :label="$t('logs.group7_a7')" width="160">
                            </el-table-column>
                            <el-table-column prop="ALLDEPARTNAME" :label="$t('logs.group7_a5')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('table1.operation')" width="80">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick_deport(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("table1.delete") }}
                                    </el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu_sender"  v-drag="{ handle: '.pop_up_text_relay_domain_edit' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_relay_domain_edit"><span class="span_pad"></span> {{$t('logs.ldap15')}}</div>
                        <p></p>
                        <div class="find">

                            <div class="find1">
                                <div class="find-text" style="padding-right: 12px;">
                                    <!-- 域名或邮箱账号 -->
                                    {{ $t("logs.notify7") }}:

                                </div>
                                <div class="block block1">
                                    <el-input type="textarea" :autosize="{ minRows: 4, }" placeholder="一行一个地址" v-model="group_users" style="margin:8px 0">
                                    </el-input>
                                </div>
                            </div>

                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_sender" :disabled="$root.jurisdiction.only_query == 0">{{ $t("tab.save") }}</el-button>
                            <el-button type="danger" @click="off_sender">{{ $t("tab.cancel") }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_sender"></div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <!-- 组规则设置 -->
        <el-tabs v-show="tanchu_rule_all" v-loading="loading">

            <!-- 组过滤规则 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.group7_b1") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="save_rule_hide()">{{ $t("logs.Policy_back") }}</el-button>

                        <el-button @click="save_rule_show()">{{ $t("logs.group7_b6") }}</el-button>
                        <el-alert :title="this.show_hint1" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table table01">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_group_regex" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="50"> </el-table-column>
                            <el-table-column prop="GROUP_NAME" :label="$t('logs.group6')">
                            </el-table-column>
                            <el-table-column prop="SHOWTYPE" :label="$t('table1.type')">
                            </el-table-column>
                            <el-table-column prop="HEADER_KEY" :label="$t('table1.header')">
                            </el-table-column>
                            <el-table-column prop="SHOWDIRECT" :label="$t('logs.firewall2_a2')">
                            </el-table-column>
                            <el-table-column prop="SCORE" :label="$t('table1.score')">
                            </el-table-column>
                            <el-table-column prop="GROUP_REGEX" :label="$t('table1.rule')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('table1.operation')">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick_group_regex(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("table1.delete") }}
                                    </el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu_rule" v-drag="{ handle: '.pop_up_text_local_domain' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_local_domain"><span class="span_pad"></span> {{$t('logs.group7_b6')}}</div>
                        <p></p>
                        <div class="find">

                            <div class="find1">
                                <div class="find-text" style="padding-right: 12px;">
                                    <!-- 策略组名 -->
                                    {{ $t("logs.group6") }}:

                                </div>
                                <div class="block block1">
                                    <p style="text-align:left;color:#0e2c5e">{{this.group_name}}</p>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right: 12px;">
                                    <!-- 类型 -->
                                    {{ $t("logs.smtpIp6") }}:

                                </div>
                                <div class="block block1">
                                    <el-select v-model="regex_type" placeholder="" @change="show_key">
                                        <el-option v-for="item in regex_type_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right: 12px;">
                                    <!-- 方向 -->
                                    {{ $t("logs.Policy_list8") }}:

                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="direct">
                                        <el-radio :label="0">{{ $t("logs.group7_a9") }}</el-radio>
                                        <el-radio :label="1">{{ $t("logs.firewall1_a2") }}</el-radio>
                                        <el-radio :label="2">{{ $t("logs.firewall1_a3") }}</el-radio>
                                        <el-radio :label="3">{{ $t("logs.group7_a8") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right: 12px;">
                                    <!-- 分数 -->
                                    {{ $t("logs.Content5") }}:

                                </div>
                                <div class="block block1">
                                    <el-input type="text" placeholder="累计分数达到50，则邮件被拒收" v-model="score" style="margin:8px 0">
                                    </el-input>
                                </div>
                            </div>
                            <div class="find1" v-if="this.header_key1==1">
                                <div class="find-text" style="padding-right: 12px;">
                                    <!-- 表达式-->
                                    {{ $t("logs.Policy_unit_regex4") }}:

                                </div>
                                <div class="block block1">
                                    <el-input type="text" placeholder="" v-model="header_key" style="margin:8px 0">
                                    </el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right: 12px;">
                                    <!-- 表达式-->
                                    {{ $t("logs.Regex_test2") }}:

                                </div>
                                <div class="block block1">
                                    <el-input type="text" placeholder="" v-model="filterregex" style="margin:8px 0">
                                    </el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_rule" :disabled="$root.jurisdiction.only_query == 0">{{ $t("tab.save") }}</el-button>
                            <el-button type="danger" @click="off_rule">{{ $t("tab.cancel") }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_rule"></div>
                </div>
            </el-tab-pane>
            <!-- 组IP白名单 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.group7_b2") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="save_rule_hide()">{{ $t("logs.Policy_back") }}</el-button>

                        <el-button @click="save_ipw_show()">{{ $t("logs.group7_b7") }}</el-button>
                        <el-alert :title="this.show_hint2" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table table01">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_group_ipw" :row-class-name="tableRowClassName">

                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')">
                            </el-table-column>
                            <el-table-column prop="GROUP_NAME" :label="$t('logs.group6')">
                            </el-table-column>

                            <el-table-column prop="IP" :label="$t('logs.Policy_unit_ip1')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('table1.operation')">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick_group_ipw(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("table1.delete") }}
                                    </el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu_ipw" v-drag="{ handle: '.pop_up_text_local_domain_edit' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_local_domain_edit"><span class="span_pad"></span> {{$t('logs.group7_b7')}}</div>
                        <p></p>
                        <div class="find">

                            <div class="find1">
                                <div class="find-text" style="padding-right: 12px;">
                                    <!-- 策略组名 -->
                                    {{ $t("logs.group6") }}:

                                </div>
                                <div class="block block1">
                                    <p style="text-align:left;color:#0e2c5e">{{this.group_name}}</p>
                                </div>
                            </div>

                            <div class="find1">
                                <div class="find-text" style="padding-right: 12px;">
                                    <!-- ip -->
                                    {{ $t("logs.Policy_unit_ip1") }}:

                                </div>
                                <div class="block block1">
                                    <el-input type="text" placeholder="" v-model="ipaddr" style="margin:8px 0">
                                    </el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_ipw" :disabled="$root.jurisdiction.only_query == 0">{{ $t("tab.save") }}</el-button>
                            <el-button type="danger" @click="off_ipw">{{ $t("tab.cancel") }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_ipw"></div>
                </div>
            </el-tab-pane>
            <!-- 组IP黑名单 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.group7_b3") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="save_rule_hide()">{{ $t("logs.Policy_back") }}</el-button>

                        <el-button @click="save_ipb_show()">{{ $t("logs.group7_b8") }}</el-button>
                        <el-alert :title="this.show_hint3" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table table01">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_group_ipb" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')">
                            </el-table-column>
                            <el-table-column prop="GROUP_NAME" :label="$t('logs.group6')">
                            </el-table-column>

                            <el-table-column prop="IP" :label="$t('logs.Policy_unit_ip1')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('table1.operation')">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick_group_ipb(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("table1.delete") }}
                                    </el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu_ipb" v-drag="{ handle: '.pop_up_text_ipcor' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_ipcor"><span class="span_pad"></span> {{$t('logs.group7_b8')}}</div>
                        <p></p>
                        <div class="find">

                            <div class="find1">
                                <div class="find-text" style="padding-right: 12px;">
                                    <!-- 策略组名 -->
                                    {{ $t("logs.group6") }}:

                                </div>
                                <div class="block block1">
                                    <p style="text-align:left;color:#0e2c5e">{{this.group_name}}</p>
                                </div>
                            </div>

                            <div class="find1">
                                <div class="find-text" style="padding-right: 12px;">
                                    <!-- ip -->
                                    {{ $t("logs.Policy_unit_ip1") }}:

                                </div>
                                <div class="block block1">
                                    <el-input type="text" placeholder="" v-model="ipaddr" style="margin:8px 0">
                                    </el-input>
                                </div>
                            </div>
                        </div>

                        <el-row> 
                            <el-button type="primary" @click="save_ipb" :disabled="$root.jurisdiction.only_query == 0">  {{ $t("tab.save") }}</el-button>
                            <el-button type="danger" @click="off_ipb">{{ $t("tab.cancel") }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_ipb"></div>
                </div>
            </el-tab-pane>
            <!-- 组from白名单 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.group7_b4") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="save_rule_hide()">{{ $t("logs.Policy_back") }}</el-button>

                        <el-button @click="save_wl_show()">{{ $t("logs.group7_b9") }}</el-button>
                        <el-alert :title="this.show_hint4" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table table01">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_group_wl" :row-class-name="tableRowClassName">

                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')">
                            </el-table-column>
                            <el-table-column prop="GROUP_NAME" :label="$t('logs.group6')">
                            </el-table-column>

                            <el-table-column prop="DNOREMAIL" :label="$t('logs.notify7')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('table1.operation')">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick_group_wl(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("table1.delete") }}
                                    </el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu_wl" v-drag="{ handle: '.pop_up_text_ipcor_edit' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_ipcor"><span class="span_pad"></span> {{$t('logs.group7_b9')}}</div>
                        <p></p>
                        <div class="find">

                            <div class="find1">
                                <div class="find-text" style="padding-right: 12px;">
                                    <!-- 策略组名 -->
                                    {{ $t("logs.group6") }}:

                                </div>
                                <div class="block block1">
                                    <p style="text-align:left;color:#0e2c5e">{{this.group_name}}</p>
                                </div>
                            </div>

                            <div class="find1">
                                <div class="find-text" style="padding-right: 12px;">
                                    <!-- ip -->
                                    {{ $t("logs.notify7") }}:

                                </div>
                                <div class="block block1">
                                    <el-input type="text" placeholder="" v-model="dnoremail" style="margin:8px 0">
                                    </el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_wl" :disabled="$root.jurisdiction.only_query == 0">{{ $t("tab.save") }}</el-button>
                            <el-button type="danger" @click="off_wl">{{ $t("tab.cancel") }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_wl"></div>
                </div>
            </el-tab-pane>
            <!-- 组from黑名单 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.group7_b5") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="save_rule_hide()">{{ $t("logs.Policy_back") }}</el-button>

                        <el-button @click="save_bl_show()">{{ $t("logs.group7_b10") }}</el-button>
                        <el-alert :title="this.show_hint5" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table table01">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_group_bl" :row-class-name="tableRowClassName">

                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')">
                            </el-table-column>
                            <el-table-column prop="GROUP_NAME" :label="$t('logs.group6')">
                            </el-table-column>

                            <el-table-column prop="DNOREMAIL" :label="$t('logs.notify7')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('table1.operation')">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick_group_bl(scope.$index, scope.row)" type="text" size="small">
                                        {{ $t("table1.delete") }}
                                    </el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu_bl" v-drag="{ handle: '.pop_up_text_tls_address' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_tls_address"><span class="span_pad"></span> {{$t('logs.group7_b10')}}</div>
                        <p></p>
                        <div class="find">

                            <div class="find1">
                                <div class="find-text" style="padding-right: 12px;">
                                    <!-- 策略组名 -->
                                    {{ $t("logs.group6") }}:

                                </div>
                                <div class="block block1">
                                    <p style="text-align:left;color:#0e2c5e">{{this.group_name}}</p>
                                </div>
                            </div>

                            <div class="find1">
                                <div class="find-text" style="padding-right: 12px;">
                                    <!-- ip -->
                                    {{ $t("logs.notify7") }}:

                                </div>
                                <div class="block block1">
                                    <el-input type="text" placeholder="" v-model="dnoremail" style="margin:8px 0">
                                    </el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_bl" :disabled="$root.jurisdiction.only_query == 0">{{ $t("tab.save") }}</el-button>
                            <el-button type="danger" @click="off_bl">{{ $t("tab.cancel") }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_bl"></div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <!-- 组收信个性化设置 -->

        <el-tabs v-show="tanchu_in_pol_all" v-loading="loading" @tab-click="dianji" v-model="activeName">
            <!-- 发件人策略 -->
            <el-tab-pane label="" name="first">
                <span slot="label"> {{ $t("logs.policy1") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="save_envfrom_hide()">{{ $t("logs.Policy_back") }}</el-button>
                        <span class="main_text"> {{ this.load_hind_pop }}</span>
                        <el-input v-model="address_pop" style="width:20%;margin-right:10px" clearable></el-input>
                        <el-button @click="save_pop_table()"> {{ $t("logs.policy6") }}</el-button>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table" v-if="envfrom_policy==0">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_group_pop" :row-class-name="tableRowClassName">
                            <el-table-column prop="SHOW_KEY" :label="$t('logs.policy7')" width="200">
                            </el-table-column>
                            <el-table-column prop="HINT" :label="$t('logs.policy8')">
                            </el-table-column>
                            <el-table-column prop="DFT_VALUE" :label="$t('logs.policy9')" width="200">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    策略用户:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="tanSend()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- 收件人策略 -->
            <el-tab-pane label="" name="second">
                <span slot="label"> {{ $t("logs.policy2") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="save_envfrom_hide()">{{ $t("logs.Policy_back") }}</el-button>
                        <span class="main_text"> {{ this.load_hind_pop }}</span>
                        <el-input v-model="address_pop" style="width:20%;margin-right:10px" clearable></el-input>
                        <el-button @click="save_pop_table()"> {{ $t("logs.policy6") }}</el-button>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table" v-if="envfrom_policy==0">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_group_pop" :row-class-name="tableRowClassName">
                            <el-table-column prop="SHOW_KEY" :label="$t('logs.policy7')" width="200">
                            </el-table-column>
                            <el-table-column prop="HINT" :label="$t('logs.policy8')">
                            </el-table-column>
                            <el-table-column prop="DFT_VALUE" :label="$t('logs.policy9')" width="200">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    策略用户:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="tanSend()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- IP策略 -->

            <el-tab-pane label="" name="third">
                <span slot="label"> {{ $t("logs.policy3") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="save_envfrom_hide()">{{ $t("logs.Policy_back") }}</el-button>
                        <span class="main_text"> {{ this.load_hind_pop }}</span>
                        <el-input v-model="address_pop" style="width:20%;margin-right:10px" clearable></el-input>
                        <el-button @click="save_pop_table()"> {{ $t("logs.policy6") }}</el-button>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table" v-if="envfrom_policy==0">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_group_pop" :row-class-name="tableRowClassName">
                            <el-table-column prop="SHOW_KEY" :label="$t('logs.policy7')" width="200">
                            </el-table-column>
                            <el-table-column prop="HINT" :label="$t('logs.policy8')">
                            </el-table-column>
                            <el-table-column prop="DFT_VALUE" :label="$t('logs.policy9')" width="200">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    策略用户:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="tanSend()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- 已设置策略列表 -->
            <el-tab-pane label="" name="fourth">
                <span slot="label"> {{$t("logs.policy4")}}</span>
                <div class="main">
                    <p>
                        <el-button @click="save_envfrom_hide()">{{ $t("logs.Policy_back") }}</el-button>

                    </p>
                </div>
                <div class="table">
                    <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList6" :row-class-name="tableRowClassName">
                        <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="60"> </el-table-column>
                        <el-table-column prop="GROUP_NAME" :label="$t('logs.group7_a1')">
                        </el-table-column>
                        <el-table-column prop="POLICY" :label="$t('logs.policy7')"> </el-table-column>
                        <el-table-column prop="NOTE_TYPE" :label="$t('logs.policy12')"> </el-table-column>
                        <el-table-column prop="OBJ" :label="$t('logs.policy13')"> </el-table-column>
                        <el-table-column prop="address" :label="$t('logs.policy14')" width="200"> <template scope="scope">
                                <el-select size="small" v-model="scope.row.ACTION" placeholder="请选择">
                                    <el-option v-for="item in actionn" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                                <span>{{ scope.row.date }}</span>
                            </template> </el-table-column>
                        <el-table-column prop="address" :label="$t('logs.audit6')"> <template slot-scope="scope">
                                <!-- 保存-->

                                <el-button @click="handleClick_in(scope.$index, scope.row)" type="text" size="small">{{ $t("table1.save") }}</el-button>

                            </template></el-table-column>
                    </el-table>
                    <div class="pop-up" v-show="tanchu" v-drag>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    策略用户:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">保存</el-button>
                            <el-button type="primary" @click="tanOff()">取消</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <div class="switch1" v-if="envfrom_policy==1">

                <div class="table table_policy">
                    <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_group_pop" :row-class-name="tableRowClassName">
                        <el-table-column prop="SHOW_KEY" :label="$t('logs.policy7')" width="160">
                        </el-table-column>
                        <el-table-column prop="HINT" :label="$t('logs.policy8')">
                        </el-table-column>
                        <el-table-column prop="DFT_VALUE" :label="$t('logs.policy9')" width="110">
                        </el-table-column>
                        <el-table-column prop="address" :label="this.cfg_hint" width="160">
                            <template scope="scope">
                                <el-select size="small" v-model="scope.row.VALUE" placeholder="请选择">
                                    <el-option v-for="item in q_action_type" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>

                            </template>
                        </el-table-column>
                        <el-table-column prop="address" :label="$t('logs.audit6')" width="80">
                            <template slot-scope="scope">
                                <!--保存-->

                                <el-button @click="save_group_list(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query == 0">{{ $t("table1.save") }}</el-button>

                            </template>
                        </el-table-column>
                    </el-table>
                </div>

            </div>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            activeName: 'first',
            pol_list_group_id: '',
            fileList_group_list: [],
            cfg_hint: '', //
            q_action_type: [],
            envfrom_policy: 0,
            // 组过滤规则
            regex_type: 'SUBJECT',
            regex_type_arr: [],
            fileList_group_regex: [],
            fileList_group_ipw: [],
            fileList_group_ipb: [],
            fileList_group_wl: [],
            fileList_group_bl: [],
            tanchu_ipw: false,
            tanchu_ipb: false,
            tanchu_wl: false,
            tanchu_bl: false,
            dnoremail: '',
            header_key: '',
            header_key1: '',
            // 策略组所属部门
            add_depapt: '',
            domain_id: '',
            domain_idd: [],
            // 策略组所属用户
            depart_id: '',
            depart_idd: [],
            include_sub_depart: '',
            fileList_group_email: [],
            fileList_group_deport: [],
            action: 1,
            actionn: [],
            tanchu_group: false,
            group_name: '',
            cur_from: '',
            cur_to: '',
            cur_connect: '',
            ipaddr: '',
            filterregex: '',
            score: '',
            direct: '',
            direct_in: '',
            unit_type: '',
            unit_type1: [],
            unit_name_edit: '',
            group_users: '',

            show_hint: '',
            show_hint1: '',
            show_hint2: '',
            show_hint3: '',
            show_hint4: '',
            show_hint5: '',
            loading: false,
            tanchu_edit: false,
            tanchu_sender: false,
            tanchu_sender_all: false,
            tanchu_in_pol_all: false,
            tanchu_rule_all: false,
            tanchu_rule: false,
            fileList_group_pop: [],
            load_hind_pop: '',
            // tanchu_rul_all: true,

            filter_cell: true,
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44",
            }, ],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS",
                },
                {
                    value: "选项2",
                    label: "增加信头标记",
                },
                {
                    value: "选项3",
                    label: "强制TLS",
                },
            ],
            checked: "",
            fileList: [],
            fileList1: [],
            fileList2: [],
            fileList3: [],
            fileList4: [],
            fileList5: [],
            fileList6: [],
            fileList7: [],
            radio: [],
            load_hind1: '',
            load_hind2: '',
            load_hind3: '',
            load_hind4: '',
            load_hind5: '',
            load_hind6: '',
            load_hind7: '',
            load_hind8: '',
            group_id: '',
            address_pop: '',
            type_pop: '',
        };
    },
    mounted() {
        this.getFileList01()
        this.getFileList1()
        this.getFileList2()
        this.getFileList3()
        this.getFileList4()
        this.getFileList5()
        this.getFileList7()
        this.getFileList6()

    },
    methods: {
        tan_group_level(){
            this.tanchu_group=true;
            this.group_name="";
        },
        dianji(a) {
            console.log(a.index)
            this.address_pop = ''
            if (a.index == 0) {
                this.type_pop = 'from'
                this.load_group_pol_from()

            } else if (a.index == 1) {
                this.type_pop = 'to'
                this.load_group_pol_from()

            } else if (a.index == 2) {
                this.type_pop = 'connect'
                this.load_group_pol_from()

            } else if (a.index == 3 && this.direct_in == 'in') {
                this.getFileList6()
            } else if (a.index == 3 && this.direct_in == 'out') {
                this.getFileList7()

            }

        },
        // 组发信个性化设置
        save_pop_table() {
            this.load_group_pol_from()
        },
        show_key(a) {
            // console.log(a)
            if (a == 'HEADERS') {
                this.header_key1 = 1

            } else {
                this.header_key1 = 0

            }
        },
        domain_id_select(domain) {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let domain_id = domain
            let str = this.$qs.stringify({
                __mode: "load_domain_depart",
                sid: sid,
                domain_id: domain_id,

            });

            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                       
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.depart_idd = res.data.ret.q_depart
                        // depart_id
                      
                        // this.$message({
                        //     type: "success",
                        //     message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        // });
                    }
                });
        },
        //组收信个性化设置
        bianji3(index, scope) {
            // console.log(index, scope)
            this.group_id = scope.GROUP_ID
            // console.log(this.group_name)
            this.tanchu_in_pol_all = true
            this.filter_cell = false
            this.direct_in = 'in'
            this.type_pop = 'from'
            this.load_group_pol_from()
            // this.dianji()
            this.activeName = 'first'

        },
        // 组发信个性化设置
        bianji4(index, scope) {
            console.log(index, scope)
            this.group_id = scope.GROUP_ID
            // console.log(this.group_name)
            this.tanchu_in_pol_all = true
            this.filter_cell = false
            this.direct_in = 'out'
            this.type_pop = 'from'
            this.load_group_pol_from()
            this.activeName = 'first'

            // this.dianji()

        },
        //组规则
        bianji2(index, scope) {
            // console.log(index, scope)
            this.group_name = scope.GROUP_NAME
            // console.log(this.group_name)
            this.tanchu_rule_all = true
            this.filter_cell = false
            this.load_group_regex()
            this.load_group_ipw()
            this.load_group_ipb()
            this.load_group_wl()
            this.load_group_bl()
            // this.getFileList_group_depart()

        },
        //组成员
        bianji1(index, scope) {
            // console.log(index, scope)
            this.group_name = scope.GROUP_NAME
            // console.log(this.group_name)
            this.tanchu_sender_all = true
            this.filter_cell = false
            this.getFileList_group_email()
            this.getFileList_group_depart()

        },
        //  保存
        handleClick_out(index, scope) {

            // console.log(index, scope)

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let group_id = scope.GROUP_ID
            let address = scope.OBJ
            let policy = scope.POLICY1
            let direct = scope.DIRECT
            let type = scope.TYPE
            let chkaction = scope.ACTION

            let str = this.$qs.stringify({
                __mode: "save_group_policy",
                sid: sid,
                group_id: group_id,
                address: address,
                policy: policy,
                direct: direct,
                type: type,
                chkaction: chkaction,

            });

            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                       
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList7()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                });

        },
        // 加载
        getFileList7() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_group_pol_list",
                        sid: sid,
                        direct: 'out',
                        group_id: this.group_id
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if(!res){
           
             this.loading = false;
            
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList7 = res.data.ret.datalist;
                        if (this.group_id != '') {
                            this.fileList6 = res.data.ret.datalist;
                        }
                        // 
                        this.load_hind8 = res.data.ret.LOAD_HINT;
                        this.actionn1 = res.data.ret.q_action;

                        // 总条数

                        this.loading = false;

                    }
                })
             
        },
        //  保存
        handleClick_in(index, scope) {

            // console.log(index, scope)

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let group_id = scope.GROUP_ID
            let address = scope.OBJ
            let policy = scope.POLICY1
            let direct = scope.DIRECT
            let type = scope.TYPE
            let chkaction = scope.ACTION

            let str = this.$qs.stringify({
                __mode: "save_group_policy",
                sid: sid,
                group_id: group_id,
                address: address,
                policy: policy,
                direct: direct,
                type: type,
                chkaction: chkaction,

            });

            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                       
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList6()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                });

        },
        // 加载
        getFileList6() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_group_pol_list",
                        sid: sid,
                        direct: 'in',
                        group_id: this.group_id
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if(!res){
           
             this.loading = false;
            
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList6 = res.data.ret.datalist;
                        this.load_hind7 = res.data.ret.LOAD_HINT;
                        this.actionn = res.data.ret.q_action;
                        // this.action = res.data.ret.ACTION;

                        // 总条数

                        this.loading = false;

                    }
                })
             
        },
        //  删除
        handleClick_black_from(index, scope) {

            // console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let dnoremail = scope.DNOREMAIL
                    let fk_grp_pol_id = scope.GROUP_ID

                    let str = this.$qs.stringify({
                        __mode: "del_group_blsender",
                        sid: sid,
                        dnoremail: dnoremail,
                        fk_grp_pol_id: fk_grp_pol_id,

                    });
                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                              
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList5()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });

        },
        // 加载
        getFileList5() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_group_allblsender",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                  if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList5 = res.data.ret.datalist;
                        this.load_hind6 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
             
        },
        //  删除
        handleClick_from(index, scope) {

            // console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let dnoremail = scope.DNOREMAIL
                    let fk_grp_pol_id = scope.GROUP_ID

                    let str = this.$qs.stringify({
                        __mode: "del_group_wlsender",
                        sid: sid,
                        dnoremail: dnoremail,
                        fk_grp_pol_id: fk_grp_pol_id,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                               
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList4()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });

        },
        // 加载
        getFileList4() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_group_allwlsender",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                  if(!res){
           
             this.loading = false;
            
          }
         else   if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList4 = res.data.ret.datalist;
                        this.load_hind5 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
             
        },
        //  删除
        handleClick_black(index, scope) {

            // console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let ipaddr = scope.ORGIP
                    let fk_grp_pol_id = scope.GROUP_ID

                    let str = this.$qs.stringify({
                        __mode: "del_group_ipbl",
                        sid: sid,
                        ipaddr: ipaddr,
                        fk_grp_pol_id: fk_grp_pol_id,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                               
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList3()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });

        },
        // 加载
        getFileList3() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_group_ipbl",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList3 = res.data.ret.datalist;
                        this.load_hind4 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
             
        },
        //  删除
        handleClick_white(index, scope) {

            // console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let ipaddr = scope.ORGIP
                    let fk_grp_pol_id = scope.GROUP_ID

                    let str = this.$qs.stringify({
                        __mode: "del_group_ipwl",
                        sid: sid,
                        ipaddr: ipaddr,
                        fk_grp_pol_id: fk_grp_pol_id,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                              
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList2()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });

        },
        // 加载
        getFileList2() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_group_ipwl",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList2 = res.data.ret.datalist;
                        this.load_hind3 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
             
        },
        //  删除
        handleClick_regex(index, scope) {

            // console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let rule_id = scope.RULE_ID

                    let str = this.$qs.stringify({
                        __mode: "del_group_regex",
                        sid: sid,
                        rule_id: rule_id,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                               
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList1()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });

        },
        // 加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_group_regex",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList1 = res.data.ret.datalist;
                        this.load_hind2 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
             
        },
        //  删除
        handleClick_group(index, scope) {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let group_name = scope.GROUP_NAME

            let str = this.$qs.stringify({
                __mode: "del_group_name",
                sid: sid,
                group_name: group_name,

            });

            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                       
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList01()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.del1')}`,
                        });
                    }
                });

        },
        // 编辑
        save_group() {

            // this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_group_name",
                sid: sid,
                group_name: this.group_name,

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu_group = false
                        this.getFileList01()
                        // 总条数

                    }
                })
             
        },
        // 加载
        getFileList01() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: " load_group_name",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                    if(!res){
           
             this.loading = false;
            
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList = res.data.ret.datalist;
                        this.load_hind1 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
             
        },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
        // 显示
        tan: function () {
            this.tanchu_group = true;
        },
        cancel_group: function () {
            this.tanchu_group = false;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
        off_sender() {
            this.tanchu_sender = false;
        },
        off_rule() {
            this.tanchu_rule = false;
        },
        off_ipw() {
            this.tanchu_ipw = false;
        },
        off_ipb() {
            this.tanchu_ipb = false;
        },
        off_wl() {
            this.tanchu_wl = false;
        },
        off_bl() {
            this.tanchu_bl = false;
        },
        // 返回
        save_envfrom_hide() {
            this.tanchu_in_pol_all = false;
            this.filter_cell = true
        },
        // 返回
        save_sender_hide() {
            this.tanchu_sender_all = false;
            this.filter_cell = true
        },
        // 返回
        save_rule_hide() {
            this.tanchu_rule_all = false;
            this.filter_cell = true
        },
        // 组成员设置显示隐藏
        save_sender_show() {
            this.tanchu_sender = true;
            this.group_users='';

        },
        // 组IP黑名单编辑
        save_wl_show() {
            this.tanchu_wl = true;
            this.dnoremail = ''

        },
        save_bl_show() {
            this.tanchu_bl = true;
            this.dnoremail = ''

        },
        // 组IP黑名单编辑
        save_ipb_show() {
            this.tanchu_ipb = true;
            this.ipaddr = ''

        },
        // 组IP白名单编辑
        save_ipw_show() {
            this.tanchu_ipw = true;
            this.ipaddr = ''
            // this.header_key = ''
            // this.regex_type = 'SUBJECT'
            // this.direct = 0
            // this.show_key()

        },
        // 组规则编辑
        save_rule_show() {
            this.tanchu_rule = true;
            this.filterregex = ''
            this.header_key = ''
            this.regex_type = 'SUBJECT'
            this.direct = 0
            this.show_key()

        },
        // 组规则设置保存
        save_rule() {
            this.$save_hint_test();
            this.$disable_hint_test();
            // this.loading = true;
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "save_group_regex",
                sid: sid,
                group_name: this.group_name,
                type: this.regex_type,
                direct: this.direct,
                score: this.score,
                header_key: this.header_key,
                filterregex: this.filterregex,

            });
            // console.log(this.filterregex)
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                       

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                      
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false
                        this.tanchu_rule = false
                        this.loading = false;
                        this.load_group_regex()
                    }
                })
             

        },
        // 加载
        getFileList_group_email() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_group_user",
                        sid: sid,
                        group_name: this.group_name
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.add_depapt = res.data.ret.ADD_DEPART_ON
                        // console.log(this.add_depapt, 'this.add_depapt')
                        this.fileList_group_email = res.data.ret.datalist;
                        // this.load_hind1 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
             
        },
        // 策略组所属部门编辑保存
        save_depart() {
            // this.loading = true;
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "save_group_depart",
                sid: sid,
                group_name: this.group_name,
                domain_id: this.domain_id,
                depart_id: this.depart_id,
                include_sub_depart: this.include_sub_depart == true ? 1 : 0
            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                       

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                      
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        // this.tanchu = false
                        // this.tanchu_sender = false
                        this.loading = false;
                        this.getFileList_group_depart()
                    }
                })
             

        },
        // 组成员设置编辑保存
        save_sender() {
            this.$save_hint_test();
            this.$disable_hint_test();
            // this.loading = true;
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "save_group_bulk_user",
                sid: sid,
                group_name: this.group_name,
                group_users: this.group_users,
                type: 1,
                bulkadd: 1,
            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList5();

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList5();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false
                        this.tanchu_sender = false
                        this.loading = false;
                        this.getFileList_group_email()
                    }
                })
             

        },
        // 组成员设置 删除
        handleClick_sender(index, scope) {

            // console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let fk_grp_pol_id = scope.GROUP_ID
                    let username = scope.USERNAME
                    let type = scope.TYPE
                    let str = this.$qs.stringify({
                        __mode: "del_group_user",
                        sid: sid,
                        fk_grp_pol_id: fk_grp_pol_id,
                        username: username,
                        type: type,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList_group_email()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });

                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });

        },
        // 策略组所属部门加载
        getFileList_group_depart() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_group_depart",
                        sid: sid,
                        group_name: this.group_name
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if(!res){
           
             this.loading = false;
            
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.add_depapt = res.data.ret.ADD_DEPART_ON
                        this.fileList_group_deport = res.data.ret.datalist;
                        this.domain_idd = res.data.ret.q_domain;
                        // this.load_hind1 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
             
        },

        // 组成员设置 删除
        handleClick_deport(index, scope) {

            // console.log(index, scope)
             this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let fk_grp_pol_id = scope.GROUP_ID
                    let depart_id = scope.DEPART_ID
                    let type = scope.TYPE
                    let str = this.$qs.stringify({
                        __mode: "del_group_depart",
                        sid: sid,
                        fk_grp_pol_id: fk_grp_pol_id,
                        depart_id: depart_id,
                        type: type,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList_group_depart()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });

                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });

        },
        // 组过滤规则加载
        load_group_regex() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_group_regex",
                        sid: sid,
                        group_name: this.group_name
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                  if(!res){
           
             this.loading = false;
            
          }
         else   if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.add_depapt = res.data.ret.ADD_DEPART_ON
                        this.fileList_group_regex = res.data.ret.datalist;
                        this.regex_type_arr = res.data.ret.q_regex_type;
                        this.score = res.data.ret.score;

                        this.show_hint1 = res.data.ret.LOAD_HINT
                        // this.load_hind1 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
             
        },
        // 组过滤规则删除
        handleClick_group_regex(index, scope) {

            console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let rule_id = scope.RULE_ID

                    let str = this.$qs.stringify({
                        __mode: "del_group_regex",
                        sid: sid,
                        rule_id: rule_id,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                               
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.load_group_regex()
                                this.$message({
                                    type: "success",
                                     message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });

                })
                .catch(() => {
                    this.$message({
                        type: "info",
                         message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });

        },
        // 组IP白名单加载
        load_group_ipw() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_group_ipwl",
                        sid: sid,
                        group_name: this.group_name
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        this.fileList_group_ipw = res.data.ret.datalist;
                        // this.regex_type_arr = res.data.ret.q_regex_type;
                        // this.score = res.data.ret.score;
 
                        this.show_hint2 = res.data.ret.LOAD_HINT
                        // this.load_hind1 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
             
        },
        // 组IP白名单删除
        handleClick_group_ipw(index, scope) {

            console.log(index, scope)
           this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let ipaddr = scope.ORGIP
                    let fk_grp_pol_id = scope.GROUP_ID

                    let str = this.$qs.stringify({
                        __mode: "del_group_ipwl",
                        sid: sid,
                        ipaddr: ipaddr,
                        fk_grp_pol_id: fk_grp_pol_id,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                               
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.load_group_ipw()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });

                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });

        },
        //  组IP白名单 编辑保存  
        save_ipw() {
        this.$save_hint_test();
        this.$disable_hint_test();
            // this.loading = true;
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "save_group_ipwl",
                sid: sid,
                group_name: this.group_name,
                ipaddr: this.ipaddr,

            });
            // console.log(this.filterregex)
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                       

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                      
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false
                        this.tanchu_ipw = false
                        this.loading = false;
                        this.load_group_ipw()
                    }
                })
             

        },
        // 组IP黑名单加载
        load_group_ipb() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_group_ipbl",
                        sid: sid,
                        group_name: this.group_name
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        this.fileList_group_ipb = res.data.ret.datalist;
                        // this.regex_type_arr = res.data.ret.q_regex_type;
                        // this.score = res.data.ret.score;

                        this.show_hint3 = res.data.ret.LOAD_HINT
                        // this.load_hind1 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
             
        },
        // 组IP黑名单删除
        handleClick_group_ipb(index, scope) {

            // console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let ipaddr = scope.ORGIP
                    let fk_grp_pol_id = scope.GROUP_ID

                    let str = this.$qs.stringify({
                        __mode: "del_group_ipbl",
                        sid: sid,
                        ipaddr: ipaddr,
                        fk_grp_pol_id: fk_grp_pol_id,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                               
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.load_group_ipb()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });

                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });

        },
        //  组IP黑名单 编辑保存  
        save_ipb() {
            // this.loading = true;
            this.$save_hint_test();
            this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "save_group_ipbl",
                sid: sid,
                group_name: this.group_name,
                ipaddr: this.ipaddr,

            });
            // console.log(this.filterregex)
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                       

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false
                        this.tanchu_ipb = false
                        this.loading = false;
                        this.load_group_ipb()
                    }
                })
             

        },
        // 组from白名单加载
        load_group_wl() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_group_allwlsender",
                        sid: sid,
                        group_name: this.group_name
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        this.fileList_group_wl = res.data.ret.datalist;
                        // this.regex_type_arr = res.data.ret.q_regex_type;
                        // this.score = res.data.ret.score;

                        this.show_hint4 = res.data.ret.LOAD_HINT
                        // this.load_hind1 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
             
        },
        // 组from白名单删除
        handleClick_group_wl(index, scope) {

            // console.log(index, scope)
             this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let dnoremail = scope.DNOREMAIL
                    let fk_grp_pol_id = scope.GROUP_ID

                    let str = this.$qs.stringify({
                        __mode: "del_group_wlsender",
                        sid: sid,
                        dnoremail: dnoremail,
                        fk_grp_pol_id: fk_grp_pol_id,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                               
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.load_group_wl()
                                 this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });

                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });

        },
        //  组from白名单编辑保存  
        save_wl() {
            // this.loading = true;
            this.$save_hint_test();
            this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "save_group_wlsender",
                sid: sid,
                group_name: this.group_name,
                dnoremail: this.dnoremail,

            });
            // console.log(this.filterregex)
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                       

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                      
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false
                        this.tanchu_wl = false
                        this.loading = false;
                        this.load_group_wl()
                    }
                })
             

        },
        // 组from白名单加载
        load_group_bl() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_group_allblsender",
                        sid: sid,
                        group_name: this.group_name
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                   if(!res){
           
             this.loading = false;
            
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        this.fileList_group_bl = res.data.ret.datalist;
                        // this.regex_type_arr = res.data.ret.q_regex_type;
                        // this.score = res.data.ret.score;

                        this.show_hint5 = res.data.ret.LOAD_HINT
                        // this.load_hind1 = res.data.ret.LOAD_HINT;
                        // 总条数

                        this.loading = false;

                    }
                })
             
        },
        // 组from白名单删除
        handleClick_group_bl(index, scope) {

            // console.log(index, scope)
             this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let dnoremail = scope.DNOREMAIL
                    let fk_grp_pol_id = scope.GROUP_ID

                    let str = this.$qs.stringify({
                        __mode: "del_group_blsender",
                        sid: sid,
                        dnoremail: dnoremail,
                        fk_grp_pol_id: fk_grp_pol_id,

                    });

                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                             
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.load_group_bl()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });

                })
                .catch(() => {
                    this.$message({
                        type: "info",
                         message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });

        },
        //  组from黑名单编辑保存  
        save_bl() {
            // this.loading = true;
        this.$save_hint_test();
        this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "save_group_blsender",
                sid: sid,
                group_name: this.group_name,
                dnoremail: this.dnoremail,

            });
            // console.log(this.filterregex)
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                     

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                     
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false
                        this.tanchu_bl = false
                        this.loading = false;
                        this.load_group_bl()
                    }
                })
             

        },
        // 
        // 发件人策略加载
        load_group_pol_from() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_group_pol_lization",
                        sid: sid,
                        group_id: this.group_id,
                        direct: this.direct_in,
                        address: this.address_pop,
                        type: this.type_pop
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                    if(!res){
           
             this.loading = false;
            
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false;

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false;

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.load_hind_pop = res.data.ret.LOAD_HINT
                        this.fileList_group_pop = res.data.ret.datalist;
                        this.q_action_type = res.data.ret.q_action_type
                        this.envfrom_policy = res.data.ret.SHOW_CFG
                        this.show_hint5 = res.data.ret.LOAD_HINT
                        this.cfg_hint = res.data.ret.CFG_HINT

                        this.loading = false;

                    }
                })
             
        },
        // 设置对象当前策略保存
        save_group_list(index, row) {
            this.$save_hint_test();
            this.$disable_hint_test();
            console.log(index, row)
            // this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let str = this.$qs.stringify({
                __mode: "save_group_policy",
                sid: sid,
                group_id: this.group_id,
                direct: this.direct_in,
                address: this.address_pop,
                type: this.type_pop,
                chkaction: row.VALUE,
                policy: row.KEY

            });
            console.log(str)
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    this.$close_hint_test();
                    this.$close_disable_hint_test();
                    console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.loading = false;

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.loading = false;

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        // this.loading = false;
                        this.load_group_pol_from()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
             
        },
        //
    },
};
</script>

<style lang="less" scoped>
.table_policy {
    /deep/ .has-gutter th:nth-child(3) {
        text-align: center;

    }

    // 表格居中位置
    /deep/ .el-table__row td:nth-child(3) {
        text-align: center;

    }

    /deep/ .el-table__row td:nth-child(5) {
        text-align: center;

    }
}

// 1
.main {
    display: flex;

    align-items: center;
    border: 2px solid #D2D7E6;
    // background: #f1f1f1;
    margin: 0px;

    text-align: left;
    //   margin-top: 20px;
}

.main p {
    height: 44px;
    width: 100%;
    display: flex;
    padding-left: 10px;
    font-size: 12px;

    align-items: center;
    // line-height: 28px;
}

.main_text {
    margin-right: 6px;
    margin-left: 6px;
    color: #0e2c5e;
}

.main .main_input {
    margin-right: 6px;
    width: 20%;
}

.main .el-select {
    margin-right: 6px
}

@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";

.pop-up .el-radio {
    margin-right: 4px;
}
</style>
